import { GLOBAL_ACTIONS, GLOBAL_RESOURCES } from 'src/constants';
import {
  createEvaluationInfo,
  RefinedEvaluationInfo,
} from 'src/helpers/createEvaluationInfo';

/**
 * Initial global evaluations to request on app load.
 *
 * - `APP_ACCESS` is the top-level gate: if denied, the user sees the generic
 *   "not authorized" error and cannot access any part of the app.
 * - Module-level actions (`HOME_ACCESS`, `ORGS_ACCESS`, `TM_ACCESS`) control
 *   navigation visibility and route protection.
 * - Instance-level actions (`TM_APPLICATION_LIST_CREATE`, etc.) control
 *   whether specific UI elements are shown.
 *
 * This constant is also consumed by the test infrastructure (`data/evaluations`)
 * to keep the default mock response in sync automatically.
 */
export const initialGlobalEvaluations: RefinedEvaluationInfo[] = [
  createEvaluationInfo(GLOBAL_ACTIONS.APP_ACCESS, GLOBAL_RESOURCES.APP),
  createEvaluationInfo(GLOBAL_ACTIONS.HOME_ACCESS, GLOBAL_RESOURCES.APP),
  createEvaluationInfo(GLOBAL_ACTIONS.INVITATIONS_ACCESS, GLOBAL_RESOURCES.APP),
  createEvaluationInfo(GLOBAL_ACTIONS.ORGS_ACCESS, GLOBAL_RESOURCES.APP),
  createEvaluationInfo(
    GLOBAL_ACTIONS.ORGS_ORGANIZATION_LIST,
    GLOBAL_RESOURCES.ORGS_ORGANIZATION,
  ),
  createEvaluationInfo(GLOBAL_ACTIONS.TM_ACCESS, GLOBAL_RESOURCES.APP),
  createEvaluationInfo(
    GLOBAL_ACTIONS.TM_APPLICATION_LIST_CREATE,
    GLOBAL_RESOURCES.TM_APPLICATION_LIST,
  ),
];
